// Dependencies
import React, { Component } from 'react';

// Multi lang
import { withTranslation } from 'react-multi-lang';
import { ALLOWANCE_APPROVED, ALLOWANCE_PAYED, DECISION_WAIT_EXPENSE_SUBMISSION, DECISION_WAIT_PAYMENT, DIRECTION_APPROVAL, FINANCE_APPROVAL, ORGANIC_UNIT_APPROVAL } from '../../../common/constants';
import { getPrettyDatetime } from '../../../common/utils/date-utils';

// Styling
import './allowance-history.scss';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

class AllowanceHistoryComponent extends Component {

    getAllowanceStateControl(allowance) {
        if(allowance.allowanceStateId === ORGANIC_UNIT_APPROVAL) {
            return <span className={'state-badge'} style={{background: '#feffb3', color: '#000000'}}>{this.props.t("allowances.form.in-approval")}</span>;
        }
        else if(allowance.allowanceStateId === FINANCE_APPROVAL) {
            return <span className={'state-badge'} style={{background: '#feffb3', color: '#000000'}}>{this.props.t("allowances.form.in-approval")}</span>;
        }
        else if(allowance.allowanceStateId === DIRECTION_APPROVAL) {
            return <span className={'state-badge'} style={{background: '#feffb3', color: '#000000'}}>{this.props.t("allowances.form.in-approval")}</span>;
        }
        else if(allowance.allowanceStateId === DECISION_WAIT_PAYMENT) {
            return <span className={'state-badge'} style={{background: '#feffb3', color: '#000000'}}>{this.props.t("allowances.form.wait-payment")}</span>;
        }
        else if(allowance.allowanceStateId === DECISION_WAIT_EXPENSE_SUBMISSION) {
            return <span className={'state-badge'} style={{background: '#feffb3', color: '#000000'}}>{this.props.t("allowances.form.wait-expense-submission")}</span>;
        }
        else if(allowance.allowanceStateId === ALLOWANCE_APPROVED || allowance.allowanceStateId === ALLOWANCE_PAYED){
            return <span className={'state-badge'} style={{background: '#C8E6C9', color: '#256029'}}>{this.props.t("allowances.form.approved")}</span>;
         }
        else {
          return <span className={'state-badge'} style={{background: '#b80406', color: '#FFFFFF'}}>{this.props.t("allowances.form.not-approved")}</span>;
       }
    }

    dateBodyTemplate(rowData, column) {
        if(rowData[column] !== null) {
          return rowData[column] !== undefined ? getPrettyDatetime(rowData[column]) : "";
        }
        else {
          return "";
        }
    }

    render() {
        return (
                this.props.allowance !== null ?
                    <div>
                        <div className="grid mgt-10">
                            <div className="col-6 t-align-left">
                                <label style={{fontSize: "16px"}}><b>{this.props.t("allowances.dialog.common.form.allowance-ref")} {this.props.allowance.allowanceRef}</b></label>
                            </div>
                            <div className="col-6 t-align-right">
                                {this.getAllowanceStateControl(this.props.allowance)}
                            </div>
                            <div className='col-12'>
                                <DataTable value={this.props.decisions} className="p-datatable-gridlines" showGridlines rows={12} dataKey="decision" responsiveLayout="scroll" emptyMessage={this.props.t("allowances.messages.no-allowance-decisions")}>
                                    <Column field="decision" header={this.props.t("allowances.form.decision-header")} style={{ minWidth: '10rem' }}  />
                                    <Column field="approver" header={this.props.t("allowances.form.approver-header")} style={{ minWidth: '10rem' }}  />
                                    <Column field="decisionDate" header={this.props.t("allowances.form.decision-date-header")} body={(data) => this.dateBodyTemplate(data, 'decisionDate')} style={{ minWidth: '12rem' }} />
                                </DataTable>
                            </div>
                        </div>
                    </div>
                    : null
        );
    }
}

export default withTranslation(AllowanceHistoryComponent);